import { Route, Routes } from "react-router-dom";
import UpdatesConnections from "./list";
const UpdatesConnectionsRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<UpdatesConnections />} />
    </Routes>
  );
};

export default UpdatesConnectionsRoutes;
